/**
 *  后台API请求地址配置
 */
const LOCAL_URL = 'http://127.0.0.1:18080' // 本地环境后台地址
const DEV_URL = 'https://examdev.pasok.cn/exam-web' // 开发环境后台地址
const TEST_URL = 'http://examtest.pasok.cn/exam-web' // 测试环境后台地址
const PRAC_URL = 'http://examprac.pasok.cn/exam-web' // 演练环境后台地址
const PRO_URL = 'https://exam.pasok.cn/exam-web' // 生产环境后台地址

const ENV_URL_MAP = {
  local: LOCAL_URL,
  dev: DEV_URL,
  test: TEST_URL,
  prac: PRAC_URL,
  prod: PRO_URL
}

const appEnv = process.env.VUE_APP_ENV
export const baseURL = appEnv && ENV_URL_MAP[appEnv]
  ? ENV_URL_MAP[appEnv]
  : (process.env.NODE_ENV === 'production' ? PRO_URL : DEV_URL)
